function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.333 10H15a.333.333 0 00-.333.333V15c0 .184.149.333.333.333h2.333a2.667 2.667 0 100-5.334z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16C31.99 7.167 24.832.01 16 0zm1.333 18H15a.333.333 0 00-.333.333v6.333a1.333 1.333 0 01-2.666 0v-16c0-.736.597-1.333 1.333-1.333h4a5.333 5.333 0 110 10.666z"
});

function SvgParking(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, props), _ref, _ref2);
}

export default SvgParking;